module.exports = __webpack_public_path__ + "ee2778f0be12f6a0c6313d02b01e09b3.png";